module.exports = __webpack_public_path__ + "img/epr-price@2x.136646c7.jpeg";